const SystemMastersType = {
  GET_ALL_BRANDS: 'GET_ALL_BRANDS',
  GET_ALL_SEASONS: 'GET_ALL_SEASONS',
  GET_ALL_CATEGORY_1: 'GET_ALL_CATEGORY_1',
  GET_ALL_CATEGORY_2: 'GET_ALL_CATEGORY_2',
  GET_ALL_CATEGORY_3: 'GET_ALL_CATEGORY_3',
  GET_ALL_CATEGORY_4: 'GET_ALL_CATEGORY_4',
  GET_ALL_LENGTHS: 'GET_ALL_LENGTHS',
  GET_ALL_COMPOSITIONS: 'GET_ALL_COMPOSITIONS',
  GET_ALL_MAIN_SAMPLE: 'GET_ALL_MAIN_SAMPLE',
  GET_ALL_PC_TYPE: 'GET_ALL_PC_TYPE',
  GET_ALL_OTHER_SAMPLES: 'GET_ALL_OTHER_SAMPLES',
  GET_ALL_PO_SIZE_MASTER: 'GET_ALL_PO_SIZE_MASTER',
  GET_ALL_BOM_TYPE_MASTER: 'GET_ALL_BOM_TYPE_MASTER',
  GET_ALL_BOM_SUB_TYPE_MASTER: 'GET_ALL_BOM_SUB_TYPE_MASTER',
  GET_ALL_BOM_COMPONENT_TYPE_MASTER: 'GET_ALL_BOM_COMPONENT_TYPE_MASTER',
  GET_ALL_PRODUCT_STATUS_MASTER: 'GET_ALL_PRODUCT_STATUS_MASTER',
  GET_ALL_UNIT_MASTER: 'GET_ALL_UNIT_MASTER',
  SET_DEFAULT_PRODUCT_STATUS: 'SET_DEFAULT_PRODUCT_STATUS',
  SAVE_RESPECTIVE_DATA: 'SAVE_RESPECTIVE_DATA',
  ACTIVE_INACTIVE: 'ACTIVE_INACTIVE',
  GET_ALL_CUSTOM_ACCORIAN: 'GET_ALL_CUSTOM_ACCORIAN',
  GET_ACCORDIAN: 'GET_ACCORDIAN',
  DELETE_FROM_SYSTEM_MASTER: 'DELETE_FROM_SYSTEM_MASTER',
  GET_SAMPLE_TRACKING: 'GET_SAMPLE_TRACKING',
  GET_SAMPLE_STATUS: 'GET_SAMPLE_STATUS',
  GET_MEASUREMENT: 'GET_MEASUREMENT',
  GET_PLACEMENT: 'GET_PLACEMENT',
  CUSTOM_ATTRIBUTE_LIST: 'CUSTOM_ATTRIBUTE_LIST',
  PARTNER_OVERVIEW_CUSTOM_ATTRIBUTE_LIST: 'PARTNER_OVERVIEW_CUSTOM_ATTRIBUTE_LIST',
  GET_ALL_FINISHES: 'GET_ALL_FINISHES',
  SET_EXCHANGE_RATE_DATA: 'SET_EXCHANGE_RATE_DATA',
  GET_MULTIPLE_CATEGORY_3: 'GET_MULTIPLE_CATEGORY_3',
  GET_MULTIPLE_CATEGORY_4: 'GET_MULTIPLE_CATEGORY_4',
  GET_USER_BRANDS: 'GET_USER_BRANDS',
  GET_USER_CATEGORIES1: 'GET_USER_CATEGORIES1',
  GET_USER_CATEGORIES2: 'GET_USER_CATEGORIES2',
  ALL_PORT_OF_LANDING: 'ALL_PORT_OF_LANDING',
  UNMOUNT_SYSTEM_MASTER: 'UNMOUNT_SYSTEM_MASTER',
  GET_COSTING_STAGE: 'GET_COSTING_STAGE',
  GET_PRODUCT_GROUP: 'GET_PRODUCT_GROUP',
  GET_DOCUMENT_TYPE: 'GET_DOCUMENT_TYPE',
  GET_PRODUCT_IDENTIFIER: 'GET_PRODUCT_IDENTIFIER',
  IDENTIFIER_TYPE: 'IDENTIFIER_TYPE',
  CLEAR_SYSTEM_MASTER: 'CLEAR_SYSTEM_MASTER',
  GET_TEST_TYPE_MASTER: 'GET_TEST_TYPE_MASTER',
  DAM_ATTRIBUTE_DROPDOWN_LIST: 'DAM_ATTRIBUTE_DROPDOWN_LIST',
  GET_LENGTH_ACCESS: 'GET_LENGTH_ACCESS',
  GET_LENGTH_IN_USE_STATUS: 'GET_LENGTH_IN_USE_STATUS',
  DAM_ATTRIBUTE_TEXT_LIST: 'DAM_ATTRIBUTE_TEXT_LIST',
  UNMOUNT_STATUS_MASTER: 'UNMOUNT_STATUS_MASTER',
  GET_ALL_BOM_SUB_COMPONENT_TYPE_MASTER: 'GET_ALL_BOM_SUB_COMPONENT_TYPE_MASTER',
  UNMOUNT_DOCUMENT_MASTER: 'UNMOUNT_DOCUMENT_MASTER',
  GET_SUPPLIER_STATUS: 'GET_SUPPLIER_STATUS',
  GET_AUTO_ID_MASTER: 'GET_AUTO_ID_MASTER',
  GET_ALL_PRODUCTCOUNT_OPTIONS: 'GET_ALL_PRODUCTCOUNT_OPTIONS',
  GET_MULTI_CUSTOM_ATTRIBUTE: 'GET_MULTI_CUSTOM_ATTRIBUTE',
  GET_PCP_CUSTOM_ATTRIBUTE: 'GET_PCP_CUSTOM_ATTRIBUTE',
  CUSTOM_ATTRIBUTE_BOM_LIST: 'CUSTOM_ATTRIBUTE_BOM_LIST',
  CUSTOM_ATTRIBUTE_SUB_BOM_LIST: 'CUSTOM_ATTRIBUTE_SUB_BOM_LIST',
  FETCH_TYPE_BASED_CATEGORY: 'FETCH_TYPE_BASED_CATEGORY',
  GET_ALL_LICENSOR: 'GET_ALL_LICENSOR',
  GET_ALL_LICENSE: 'GET_ALL_LICENSE',
  GET_LICENSE_DROPDOWN_LIST: 'GET_LICENSE_DROPDOWN_LIST',
  GET_ALL_LIKENESS: 'GET_ALL_LIKENESS',
  GET_ALL_SUB_BRAND: 'GET_ALL_SUB_BRAND',
  GET_SUB_BRAND_ACCESS: 'GET_SUB_BRAND_ACCESS',
  CLEAR_SUB_BRAND: 'CLEAR_SUB_BRAND',
  SET_SUB_BRAND_ACCESS: 'SET_SUB_BRAND_ACCESS',
  GET_MULTI_SUB_BRAND: 'GET_MULTI_SUB_BRAND',
  GET_ALL_INCOTERMS: 'GET_ALL_INCOTERMS',
  GET_ACTIVE_INCOTERMS: 'GET_ACTIVE_INCOTERMS',
  GET_CUSTOM_ATTRIBUTE_DETAIL: 'GET_CUSTOM_ATTRIBUTE_DETAIL',
  GET_ALL_PLACEMENT_SUB_BRAND: 'GET_ALL_PLACEMENT_SUB_BRAND',
  GET_PLACEMENT_NAMES: 'GET_PLACEMENT_NAMES',
  GET_CAT_BASED_ON_PT: 'GET_CAT_BASED_ON_PT',
  GET_BOM_SOURCE_CUSTOM_ATTRIBUTE: 'GET_BOM_SOURCE_CUSTOM_ATTRIBUTE',
  GET_ALL_COLOUR_GROUPS: 'GET_ALL_COLOUR_GROUPS',
  GET_COMPOSITION_PROCESS: 'GET_COMPOSITION_PROCESS',
  GET_BOM_COMPONENT_TYPE: 'GET_BOM_COMPONENT_TYPE',
  GET_PRODUCT_TYPE_PROCESS: 'GET_PRODUCT_TYPE_PROCESS',
  GET_ALL_SAMPLE_TYPE_GROUPS: 'GET_ALL_SAMPLE_TYPE_GROUPS',
  GET_ALL_ADDITIONAL_VARIABLES: 'GET_ALL_ADDITIONAL_VARIABLES',
  GET_ALL_SIZE_RANGES_MASTER: 'GET_ALL_SIZE_RANGES_MASTER',
  GET_ALL_PC_TYPE_ADMIN: 'GET_ALL_PC_TYPE_ADMIN',
  GET_FILTER_SEASONS: 'GET_FILTER_SEASONS',
};

export default SystemMastersType;
